import React, { useMemo } from 'react'

import { HeaderProps } from './header'
import HeaderColumn from './HeaderColumn'
import { DEFAULT_TABLE_PROPS } from '../../constants'

const Header = <T,>({
  tableInstance,
  sortFilter,
  tableProps = DEFAULT_TABLE_PROPS,
}: HeaderProps<T>): React.ReactElement => {
  const headerGroups = useMemo(
    () => tableInstance.getHeaderGroups(),
    [tableInstance],
  )

  return (
    <>
      {headerGroups.map((headerGroup) => {
        return (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header, index) => {
              return (
                <HeaderColumn
                  key={header.id}
                  setSort={sortFilter.setSort}
                  header={header}
                  activeSort={sortFilter.sort}
                  tableProps={tableProps}
                />
              )
            })}
          </tr>
        )
      })}
    </>
  )
}

export default Header
